import { createSignal } from 'solid-js';
import { ApiError } from '~/shared/api/http-client';

const [forbiddenAt, setForbiddenAt] = createSignal<string | null>(null);

export { forbiddenAt };

export const clearForbidden = (): void => {
  setForbiddenAt(null);
};

type ObservedQuery = { queryKey: readonly unknown[]; meta?: Record<string, unknown> | undefined };

const startedAt = new WeakMap<object, string>();

export const onQueryFetch = (query: object, pathname: string): void => {
  startedAt.set(query, pathname);
};

export const keyStartsWith = (key: readonly unknown[], prefix: readonly unknown[]): boolean =>
  prefix.length > 0
  && prefix.length <= key.length
  && prefix.every((part, i) => JSON.stringify(part) === JSON.stringify(key[i]));

export const onQueryError = (
  error: unknown,
  query: ObservedQuery,
  pathname: string,
  mainQueryOf: (pathname: string) => readonly unknown[] | null,
): void => {
  if (!(error instanceof ApiError) || error.status !== 403) return;
  if (query.meta?.peripheral === true) return;
  const started = startedAt.get(query) ?? pathname;
  if (started !== pathname) return;
  const main = mainQueryOf(started);
  if (main === null || !keyStartsWith(query.queryKey, main)) return;
  setForbiddenAt(started);
};
